/**
 * Custom welcome message for Orchestrator and Agent dialogs
 */

export const getWelcomeMessage = (firstName, agentName, taskName) => {
  return `Hello ${firstName}, I'm ${agentName}, your AI agent for the ${taskName} of your project.

You can chat with me, speak to me, upload a document, or even connect me to your existing Knowledge Hub — whatever works best for you!

Ready to get started?`;
};